import { useState, useEffect } from 'react';
import { applyDocumentLocale, resolveInitialLocale, RTL_LOCALES } from '../utils/locale';
import i18n from '../i18n';
export function useLocale() {
    const [locale, setLocaleState] = useState(() => resolveInitialLocale());
    useEffect(() => {
        applyDocumentLocale(locale);
        i18n.changeLanguage(locale);
    }, [locale]);
    const setLocale = (value) => {
        localStorage.setItem('projectmanmd-locale', value);
        setLocaleState(value);
    };
    return { locale, setLocale, isRTL: RTL_LOCALES.includes(locale) };
}
//# sourceMappingURL=useLocale.js.map